import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/mobile-images/wx-error-bg1.png'


const _withScopeId = n => (_pushScopeId("data-v-bef476de"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "weixin-tips" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "container" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "tip1",
    alt: "",
    srcset: ""
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "tips-text" }, [
    /*#__PURE__*/_createElementVNode("div", null, "如果您使用微信支付，请在浏览器打开页面")
  ])
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "shade" }, null, -1))


export default /*#__PURE__*/_defineComponent({
  __name: 'WXTips',
  emits: ["close"],
  setup(__props, { emit: emits }) {


const close = () => {
  emits("close");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", {
      class: "button",
      onClick: close
    }, "我知道了")
  ]))
}
}

})